let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7dkq2")).then(() => parcelRequire('vUe0y'));